module.exports = __webpack_public_path__ + "static/img/12.9da9c1f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/zh/12.png
// module id = RJGe
// module chunks = 0